import { Area } from "../Area/Area";

export class DistanceDuration{

    constructor(){
        this.A = {
            lat:null,
            lng:null
        }
        this.B = {
            lat:null,
            lng:null
        }
        this.result = {
            distance:{
                text:"",
                value:null
            },
            duration:{
                text:"",
                value:null
            }
        }
    }
    A:{
        lat:any;
        lng:any;
    }
    B:{
        lat:any;
        lng:any;
    }
    result:{
        distance:{
            text:any;
            value:number;
        }
        duration:{
            text:any;
            value:number;
        }
    }
}

export class Matrix{
    message:string;
    status:boolean;
    data:Array<DistanceDuration>;



    public static getClosestPoint(source: Area, areas: Array<Area>): { closest: Area, durationFromSource: number } {

    
        var closest: Area = closest = areas[0];
        var lowest: any = this.getDistanceDuration(source, closest,[]).result.duration.value;
        var a: Area = null;

        for (var i = 0; i < areas.length; i++) {

            a = areas[i];

            var duration: number = this.getDistanceDuration(source, a, []).result.duration.value;

            if (duration < lowest) {
                closest = a;
                lowest = duration;
            }
        }

        return { closest: closest, durationFromSource: lowest };
    }

    static getDistanceDurationMany(source:Area,areas:Array<Area>,matrix:Array<DistanceDuration>){
        areas.forEach(a =>{
            a.distanceDurationFromSource = this.getDistanceDuration(source,a,matrix);
        }); 
    }


    static getDistanceDuration(source:Area,area:Area,matrix:Array<DistanceDuration>) : DistanceDuration{
        
        var s = source.getLatLng();
        var d = area.getLatLng();
        var res = matrix.find(x => (x.A.lat == s.lat.toString() && x.A.lng == s.lng.toString()) && (x.B.lat == d.lat.toString() && x.B.lng == d.lng.toString()));
        if(res == null){
            //Fallback to Haversine Formula
            var distanceInKm = HaversineFormula.getDistanceFromLatLonInKm(s.lat,s.lng,d.lat,d.lng);
            var speed = 0.009698573; //Assumed Speed
            var assumedTime = distanceInKm / speed;

            res = new DistanceDuration();
            res.A.lat = s.lat;
            res.A.lng = s.lng;
            res.B.lat = d.lat;
            res.B.lng = d.lng;
            res.result.distance.value = distanceInKm;
            res.result.duration.value = assumedTime;
            return res;
        }else{
            return res;
        }
    }
}

export class HaversineFormula {

    static getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = HaversineFormula.deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = HaversineFormula.deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(HaversineFormula.deg2rad(lat1)) * Math.cos(HaversineFormula.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    static deg2rad(deg) {
        return deg * (Math.PI / 180)
    }
}